export default __webpack_public_path__ + "beta-maps-example-point-annotation-thumbnail-480-38380b43bdbfcf9db4f783b0b06715a8.png";